const

	SERVICES = [
		{
			id: "thumbnails",
			icon: "image",
			title: "Thumbnails",
			description: "Check out thumbnails of your streams"
		},
		{
			id: "rec",
			icon: "circle",
			title: "Recordings",
			description: "Browse recordings of your past broadcasts"
		},
		{
			id: "replay",
			icon: "sync",
			title: "Replay",
			description: "Play your previous streams, or rewind your current broadcasting session"
		},
		{
			id: "remix",
			icon: "headphones-alt",
			title: "reMix",
			description: "Upload Videos and Change your stream content in realtime just like a TV producer"
		},
		{
			id: "watermark",
			icon: "stamp",
			title: "Watermark Manager",
			description: "Configure the watermarks to use for your streams"
		},
		{
			id: "chromakey",
			icon: "user",
			title: "Choma Key Setup",
			description: "Configure the chroma key live processing features"
		}
	];

export default SERVICES;
